import { Routes, Route, useLocation } from "react-router-dom";
import {
  Navbar,
  Footer,
  PrivacyPolicy,
  TermsnConditions,
  Disclaimer,
  ShippingandDelivery,
  ReturnPolicy,
  Error404,
  Home,
  Aboutus,
  Contactus,
  Services,
} from "./routes/Routes";

import seoData from "./assets/data/seo.json";

import PrivateRoute from "./hooks/PrivateRoute";
import Login from "./routes/auth/login";
import Dashboard from "./routes/auth/dashboard";
import Leads from "./routes/auth/Leads";
import AdminContactus from "./routes/auth/AdminContactus";
import AdminNavbar from "./routes/auth/AdminNavbar";
import GoogelAnalytics from "./routes/auth/GoogelAnalytics";

import {
  /*Web Development */
  Slimming,
  SubPages,
} from "./routes/Routes";

import {
  SlimmingWeightManagement,
  HIFUBody,
  BeautyFacials,
  AcneScarReduction,
  PigmentationTanning,
  AntiAgingTreatments,
  LaserHairRemoval,
  HairCareRestoration,
  PRPHairTherapy,
  HairTransplant,
  DentalWhitening,
  DentalImplants,
  RoutineDentalCare,
} from "./assets/data/PageData";
import Gallery from "./routes/Gallery";
import MyAccount from "./routes/auth/MyAccount";
import Testimonials from "./routes/Testimonials";

const routes = [
  { path: "/", element: <Home /> },
  { path: "/*", element: <Error404 /> },

  { path: "/login", element: <Login /> },
  {
    path: "/auth/dashboard",
    element: (
      <PrivateRoute>
        <Dashboard />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/contactus",
    element: (
      <PrivateRoute>
        <AdminContactus />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/leads",
    element: (
      <PrivateRoute>
        <Leads />
      </PrivateRoute>
    ),
  },
  {
    path: "/auth/google-analytics",
    element: (
      <PrivateRoute>
        <GoogelAnalytics />
      </PrivateRoute>
    ),
  },

  {
    path: "/auth/my-account",
    element: (
      <PrivateRoute>
        <MyAccount />
      </PrivateRoute>
    ),
  },
  { path: "/testimonials", element: <Testimonials /> },
  { path: "/aboutus", element: <Aboutus /> },
  { path: "/contactus", element: <Contactus /> },
  { path: "/Legal/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/Legal/terms-and-conditions", element: <TermsnConditions /> },
  { path: "/Legal/return-policy", element: <ReturnPolicy /> },
  { path: "/Legal/shipping-and-delivery", element: <ShippingandDelivery /> },
  { path: "/Legal/disclaimer", element: <Disclaimer /> },

  { path: "/gallery", element: <Gallery /> },
  { path: "/services", element: <Services /> },

  /*---------Slimming---------*/
  { path: "/services/slimming", element: <Slimming /> },

  {
    path: "/services/slimming/slimming-weight-management",
    element: <SubPages pageData={SlimmingWeightManagement} seoData={seoData} />,
  },
  {
    path: "/services/slimming/hifu-body",
    element: <SubPages pageData={HIFUBody} seoData={seoData} />,
  },

  /*---------Slimming End---------*/

  /*---------Skin Care---------*/
  {
    path: "/services/skin-care/beauty-facials",
    element: <SubPages pageData={BeautyFacials} seoData={seoData} />,
  },
  {
    path: "/services/skin-care/acne-scar-reduction",
    element: <SubPages pageData={AcneScarReduction} seoData={seoData} />,
  },
  {
    path: "/services/skin-care/pigmentation-tanning",
    element: <SubPages pageData={PigmentationTanning} seoData={seoData} />,
  },
  {
    path: "/services/skin-care/pigmentation-tanning",
    element: <SubPages pageData={PigmentationTanning} seoData={seoData} />,
  },
  {
    path: "/services/skin-care/anti-aging-treatments",
    element: <SubPages pageData={AntiAgingTreatments} seoData={seoData} />,
  },
  {
    path: "/services/skin-care/laser-hair-removal",
    element: <SubPages pageData={LaserHairRemoval} seoData={seoData} />,
  },
  // Hair Care Services
  {
    path: "/services/hair-care/hair-care-restoration",
    element: <SubPages pageData={HairCareRestoration} seoData={seoData} />,
  },
  {
    path: "/services/hair-care/prp-hair-therapy",
    element: <SubPages pageData={PRPHairTherapy} seoData={seoData} />,
  },
  {
    path: "/services/hair-care/hair-transplant",
    element: <SubPages pageData={HairTransplant} seoData={seoData} />,
  },

  // Dental Care Services
  {
    path: "/services/dental-care/dental-whitening",
    element: <SubPages pageData={DentalWhitening} seoData={seoData} />,
  },
  {
    path: "/services/dental-care/dental-implants",
    element: <SubPages pageData={DentalImplants} seoData={seoData} />,
  },
  {
    path: "/services/dental-care/routine-dental-care",
    element: <SubPages pageData={RoutineDentalCare} seoData={seoData} />,
  },
];

export function App() {
  const location = useLocation();

  // Any route that starts with "/auth" (e.g., /auth/dashboard, /auth/contactus)
  const isAuthRoute = location.pathname.startsWith("/auth");
  window.scrollTo(0, 0);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Show AdminNavbar only on /auth pages */}
      {isAuthRoute && <AdminNavbar />}
      {/* Show Main Navbar on all non-auth pages */}
      {!isAuthRoute && <Navbar />}
      <div className="flex flex-1">
        <div
          className={`flex-1 min-w-0 transition-all duration-300 ${
            isAuthRoute ? "mt-14 md:ml-64" : "mt-0"
          }`}
        >
          <Routes location={location} key={location.pathname}>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}
          </Routes>

          {/* Footer only on non-auth pages */}
          {!isAuthRoute && <Footer />}
        </div>{" "}
      </div>{" "}
    </div>
  );
}

export default App;
